// source: webrtc.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var talk$api_pb = require('./talk-api_pb.js');
goog.object.extend(proto, talk$api_pb);
goog.exportSymbol('proto.talk_api.ClientSignaling', null, global);
goog.exportSymbol('proto.talk_api.ClientSignaling.MessageCase', null, global);
goog.exportSymbol('proto.talk_api.ICECandidate', null, global);
goog.exportSymbol('proto.talk_api.ICEServer', null, global);
goog.exportSymbol('proto.talk_api.ServerSignaling', null, global);
goog.exportSymbol('proto.talk_api.ServerSignaling.MessageCase', null, global);
goog.exportSymbol('proto.talk_api.WebRTCConfig', null, global);
goog.exportSymbol('proto.talk_api.WebRTCSDP', null, global);
goog.exportSymbol('proto.talk_api.WebRTCSDP.SDPType', null, global);
goog.exportSymbol('proto.talk_api.WebTalkRequest', null, global);
goog.exportSymbol('proto.talk_api.WebTalkRequest.RequestCase', null, global);
goog.exportSymbol('proto.talk_api.WebTalkResponse', null, global);
goog.exportSymbol('proto.talk_api.WebTalkResponse.DataCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.ICEServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.ICEServer.repeatedFields_, null);
};
goog.inherits(proto.talk_api.ICEServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.ICEServer.displayName = 'proto.talk_api.ICEServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.ICECandidate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.ICECandidate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.ICECandidate.displayName = 'proto.talk_api.ICECandidate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.WebRTCSDP = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.talk_api.WebRTCSDP, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.WebRTCSDP.displayName = 'proto.talk_api.WebRTCSDP';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.ClientSignaling = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.ClientSignaling.oneofGroups_);
};
goog.inherits(proto.talk_api.ClientSignaling, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.ClientSignaling.displayName = 'proto.talk_api.ClientSignaling';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.ServerSignaling = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.ServerSignaling.oneofGroups_);
};
goog.inherits(proto.talk_api.ServerSignaling, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.ServerSignaling.displayName = 'proto.talk_api.ServerSignaling';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.WebRTCConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.talk_api.WebRTCConfig.repeatedFields_, null);
};
goog.inherits(proto.talk_api.WebRTCConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.WebRTCConfig.displayName = 'proto.talk_api.WebRTCConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.WebTalkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.WebTalkRequest.oneofGroups_);
};
goog.inherits(proto.talk_api.WebTalkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.WebTalkRequest.displayName = 'proto.talk_api.WebTalkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.talk_api.WebTalkResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.talk_api.WebTalkResponse.oneofGroups_);
};
goog.inherits(proto.talk_api.WebTalkResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.talk_api.WebTalkResponse.displayName = 'proto.talk_api.WebTalkResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.ICEServer.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.ICEServer.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.ICEServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.ICEServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ICEServer.toObject = function(includeInstance, msg) {
  var f, obj = {
    urlsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    username: jspb.Message.getFieldWithDefault(msg, 2, ""),
    credential: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.ICEServer}
 */
proto.talk_api.ICEServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.ICEServer;
  return proto.talk_api.ICEServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.ICEServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.ICEServer}
 */
proto.talk_api.ICEServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUrls(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsername(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCredential(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.ICEServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.ICEServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.ICEServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ICEServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrlsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getUsername();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCredential();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * repeated string urls = 1;
 * @return {!Array<string>}
 */
proto.talk_api.ICEServer.prototype.getUrlsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.talk_api.ICEServer} returns this
 */
proto.talk_api.ICEServer.prototype.setUrlsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.talk_api.ICEServer} returns this
 */
proto.talk_api.ICEServer.prototype.addUrls = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.ICEServer} returns this
 */
proto.talk_api.ICEServer.prototype.clearUrlsList = function() {
  return this.setUrlsList([]);
};


/**
 * optional string username = 2;
 * @return {string}
 */
proto.talk_api.ICEServer.prototype.getUsername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ICEServer} returns this
 */
proto.talk_api.ICEServer.prototype.setUsername = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string credential = 3;
 * @return {string}
 */
proto.talk_api.ICEServer.prototype.getCredential = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ICEServer} returns this
 */
proto.talk_api.ICEServer.prototype.setCredential = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.ICECandidate.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.ICECandidate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.ICECandidate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ICECandidate.toObject = function(includeInstance, msg) {
  var f, obj = {
    candidate: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sdpmid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sdpmlineindex: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usernamefragment: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.ICECandidate}
 */
proto.talk_api.ICECandidate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.ICECandidate;
  return proto.talk_api.ICECandidate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.ICECandidate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.ICECandidate}
 */
proto.talk_api.ICECandidate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCandidate(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdpmid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSdpmlineindex(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUsernamefragment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.ICECandidate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.ICECandidate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.ICECandidate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ICECandidate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCandidate();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSdpmid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSdpmlineindex();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUsernamefragment();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string candidate = 1;
 * @return {string}
 */
proto.talk_api.ICECandidate.prototype.getCandidate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ICECandidate} returns this
 */
proto.talk_api.ICECandidate.prototype.setCandidate = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string sdpMid = 2;
 * @return {string}
 */
proto.talk_api.ICECandidate.prototype.getSdpmid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ICECandidate} returns this
 */
proto.talk_api.ICECandidate.prototype.setSdpmid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 sdpMLineIndex = 3;
 * @return {number}
 */
proto.talk_api.ICECandidate.prototype.getSdpmlineindex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.ICECandidate} returns this
 */
proto.talk_api.ICECandidate.prototype.setSdpmlineindex = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string usernameFragment = 4;
 * @return {string}
 */
proto.talk_api.ICECandidate.prototype.getUsernamefragment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ICECandidate} returns this
 */
proto.talk_api.ICECandidate.prototype.setUsernamefragment = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.WebRTCSDP.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.WebRTCSDP.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.WebRTCSDP} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebRTCSDP.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sdp: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.WebRTCSDP}
 */
proto.talk_api.WebRTCSDP.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.WebRTCSDP;
  return proto.talk_api.WebRTCSDP.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.WebRTCSDP} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.WebRTCSDP}
 */
proto.talk_api.WebRTCSDP.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.talk_api.WebRTCSDP.SDPType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.WebRTCSDP.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.WebRTCSDP.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.WebRTCSDP} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebRTCSDP.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSdp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.talk_api.WebRTCSDP.SDPType = {
  SDP_TYPE_UNSPECIFIED: 0,
  OFFER: 1,
  ANSWER: 2
};

/**
 * optional SDPType type = 1;
 * @return {!proto.talk_api.WebRTCSDP.SDPType}
 */
proto.talk_api.WebRTCSDP.prototype.getType = function() {
  return /** @type {!proto.talk_api.WebRTCSDP.SDPType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.talk_api.WebRTCSDP.SDPType} value
 * @return {!proto.talk_api.WebRTCSDP} returns this
 */
proto.talk_api.WebRTCSDP.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string sdp = 2;
 * @return {string}
 */
proto.talk_api.WebRTCSDP.prototype.getSdp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.WebRTCSDP} returns this
 */
proto.talk_api.WebRTCSDP.prototype.setSdp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.ClientSignaling.oneofGroups_ = [[2,3,4]];

/**
 * @enum {number}
 */
proto.talk_api.ClientSignaling.MessageCase = {
  MESSAGE_NOT_SET: 0,
  SDP: 2,
  ICECANDIDATE: 3,
  DISCONNECT: 4
};

/**
 * @return {proto.talk_api.ClientSignaling.MessageCase}
 */
proto.talk_api.ClientSignaling.prototype.getMessageCase = function() {
  return /** @type {proto.talk_api.ClientSignaling.MessageCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.ClientSignaling.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.ClientSignaling.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.ClientSignaling.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.ClientSignaling} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ClientSignaling.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sdp: (f = msg.getSdp()) && proto.talk_api.WebRTCSDP.toObject(includeInstance, f),
    icecandidate: (f = msg.getIcecandidate()) && proto.talk_api.ICECandidate.toObject(includeInstance, f),
    disconnect: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.ClientSignaling}
 */
proto.talk_api.ClientSignaling.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.ClientSignaling;
  return proto.talk_api.ClientSignaling.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.ClientSignaling} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.ClientSignaling}
 */
proto.talk_api.ClientSignaling.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 2:
      var value = new proto.talk_api.WebRTCSDP;
      reader.readMessage(value,proto.talk_api.WebRTCSDP.deserializeBinaryFromReader);
      msg.setSdp(value);
      break;
    case 3:
      var value = new proto.talk_api.ICECandidate;
      reader.readMessage(value,proto.talk_api.ICECandidate.deserializeBinaryFromReader);
      msg.setIcecandidate(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisconnect(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.ClientSignaling.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.ClientSignaling.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.ClientSignaling} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ClientSignaling.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSdp();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.talk_api.WebRTCSDP.serializeBinaryToWriter
    );
  }
  f = message.getIcecandidate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.talk_api.ICECandidate.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string sessionId = 1;
 * @return {string}
 */
proto.talk_api.ClientSignaling.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ClientSignaling} returns this
 */
proto.talk_api.ClientSignaling.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WebRTCSDP sdp = 2;
 * @return {?proto.talk_api.WebRTCSDP}
 */
proto.talk_api.ClientSignaling.prototype.getSdp = function() {
  return /** @type{?proto.talk_api.WebRTCSDP} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.WebRTCSDP, 2));
};


/**
 * @param {?proto.talk_api.WebRTCSDP|undefined} value
 * @return {!proto.talk_api.ClientSignaling} returns this
*/
proto.talk_api.ClientSignaling.prototype.setSdp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.talk_api.ClientSignaling.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.ClientSignaling} returns this
 */
proto.talk_api.ClientSignaling.prototype.clearSdp = function() {
  return this.setSdp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ClientSignaling.prototype.hasSdp = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ICECandidate iceCandidate = 3;
 * @return {?proto.talk_api.ICECandidate}
 */
proto.talk_api.ClientSignaling.prototype.getIcecandidate = function() {
  return /** @type{?proto.talk_api.ICECandidate} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.ICECandidate, 3));
};


/**
 * @param {?proto.talk_api.ICECandidate|undefined} value
 * @return {!proto.talk_api.ClientSignaling} returns this
*/
proto.talk_api.ClientSignaling.prototype.setIcecandidate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.talk_api.ClientSignaling.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.ClientSignaling} returns this
 */
proto.talk_api.ClientSignaling.prototype.clearIcecandidate = function() {
  return this.setIcecandidate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ClientSignaling.prototype.hasIcecandidate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool disconnect = 4;
 * @return {boolean}
 */
proto.talk_api.ClientSignaling.prototype.getDisconnect = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.ClientSignaling} returns this
 */
proto.talk_api.ClientSignaling.prototype.setDisconnect = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.talk_api.ClientSignaling.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.talk_api.ClientSignaling} returns this
 */
proto.talk_api.ClientSignaling.prototype.clearDisconnect = function() {
  return jspb.Message.setOneofField(this, 4, proto.talk_api.ClientSignaling.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ClientSignaling.prototype.hasDisconnect = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.ServerSignaling.oneofGroups_ = [[2,3,4,5,6,7]];

/**
 * @enum {number}
 */
proto.talk_api.ServerSignaling.MessageCase = {
  MESSAGE_NOT_SET: 0,
  CONFIG: 2,
  SDP: 3,
  ICECANDIDATE: 4,
  READY: 5,
  CLEAR: 6,
  ERROR: 7
};

/**
 * @return {proto.talk_api.ServerSignaling.MessageCase}
 */
proto.talk_api.ServerSignaling.prototype.getMessageCase = function() {
  return /** @type {proto.talk_api.ServerSignaling.MessageCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.ServerSignaling.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.ServerSignaling.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.ServerSignaling.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.ServerSignaling} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ServerSignaling.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    config: (f = msg.getConfig()) && proto.talk_api.WebRTCConfig.toObject(includeInstance, f),
    sdp: (f = msg.getSdp()) && proto.talk_api.WebRTCSDP.toObject(includeInstance, f),
    icecandidate: (f = msg.getIcecandidate()) && proto.talk_api.ICECandidate.toObject(includeInstance, f),
    ready: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    clear: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    error: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.ServerSignaling}
 */
proto.talk_api.ServerSignaling.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.ServerSignaling;
  return proto.talk_api.ServerSignaling.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.ServerSignaling} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.ServerSignaling}
 */
proto.talk_api.ServerSignaling.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionid(value);
      break;
    case 2:
      var value = new proto.talk_api.WebRTCConfig;
      reader.readMessage(value,proto.talk_api.WebRTCConfig.deserializeBinaryFromReader);
      msg.setConfig(value);
      break;
    case 3:
      var value = new proto.talk_api.WebRTCSDP;
      reader.readMessage(value,proto.talk_api.WebRTCSDP.deserializeBinaryFromReader);
      msg.setSdp(value);
      break;
    case 4:
      var value = new proto.talk_api.ICECandidate;
      reader.readMessage(value,proto.talk_api.ICECandidate.deserializeBinaryFromReader);
      msg.setIcecandidate(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReady(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setClear(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.ServerSignaling.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.ServerSignaling.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.ServerSignaling} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.ServerSignaling.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.talk_api.WebRTCConfig.serializeBinaryToWriter
    );
  }
  f = message.getSdp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.talk_api.WebRTCSDP.serializeBinaryToWriter
    );
  }
  f = message.getIcecandidate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.talk_api.ICECandidate.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string sessionId = 1;
 * @return {string}
 */
proto.talk_api.ServerSignaling.prototype.getSessionid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.setSessionid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional WebRTCConfig config = 2;
 * @return {?proto.talk_api.WebRTCConfig}
 */
proto.talk_api.ServerSignaling.prototype.getConfig = function() {
  return /** @type{?proto.talk_api.WebRTCConfig} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.WebRTCConfig, 2));
};


/**
 * @param {?proto.talk_api.WebRTCConfig|undefined} value
 * @return {!proto.talk_api.ServerSignaling} returns this
*/
proto.talk_api.ServerSignaling.prototype.setConfig = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.talk_api.ServerSignaling.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.clearConfig = function() {
  return this.setConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.hasConfig = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional WebRTCSDP sdp = 3;
 * @return {?proto.talk_api.WebRTCSDP}
 */
proto.talk_api.ServerSignaling.prototype.getSdp = function() {
  return /** @type{?proto.talk_api.WebRTCSDP} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.WebRTCSDP, 3));
};


/**
 * @param {?proto.talk_api.WebRTCSDP|undefined} value
 * @return {!proto.talk_api.ServerSignaling} returns this
*/
proto.talk_api.ServerSignaling.prototype.setSdp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.talk_api.ServerSignaling.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.clearSdp = function() {
  return this.setSdp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.hasSdp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ICECandidate iceCandidate = 4;
 * @return {?proto.talk_api.ICECandidate}
 */
proto.talk_api.ServerSignaling.prototype.getIcecandidate = function() {
  return /** @type{?proto.talk_api.ICECandidate} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.ICECandidate, 4));
};


/**
 * @param {?proto.talk_api.ICECandidate|undefined} value
 * @return {!proto.talk_api.ServerSignaling} returns this
*/
proto.talk_api.ServerSignaling.prototype.setIcecandidate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.talk_api.ServerSignaling.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.clearIcecandidate = function() {
  return this.setIcecandidate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.hasIcecandidate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool ready = 5;
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.getReady = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.setReady = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.talk_api.ServerSignaling.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.clearReady = function() {
  return jspb.Message.setOneofField(this, 5, proto.talk_api.ServerSignaling.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.hasReady = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool clear = 6;
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.getClear = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.setClear = function(value) {
  return jspb.Message.setOneofField(this, 6, proto.talk_api.ServerSignaling.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.clearClear = function() {
  return jspb.Message.setOneofField(this, 6, proto.talk_api.ServerSignaling.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.hasClear = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string error = 7;
 * @return {string}
 */
proto.talk_api.ServerSignaling.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.setError = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.talk_api.ServerSignaling.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.talk_api.ServerSignaling} returns this
 */
proto.talk_api.ServerSignaling.prototype.clearError = function() {
  return jspb.Message.setOneofField(this, 7, proto.talk_api.ServerSignaling.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.ServerSignaling.prototype.hasError = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.talk_api.WebRTCConfig.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.WebRTCConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.WebRTCConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.WebRTCConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebRTCConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    iceserversList: jspb.Message.toObjectList(msg.getIceserversList(),
    proto.talk_api.ICEServer.toObject, includeInstance),
    audiocodec: jspb.Message.getFieldWithDefault(msg, 2, ""),
    samplerate: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.WebRTCConfig}
 */
proto.talk_api.WebRTCConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.WebRTCConfig;
  return proto.talk_api.WebRTCConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.WebRTCConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.WebRTCConfig}
 */
proto.talk_api.WebRTCConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.talk_api.ICEServer;
      reader.readMessage(value,proto.talk_api.ICEServer.deserializeBinaryFromReader);
      msg.addIceservers(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiocodec(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSamplerate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.WebRTCConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.WebRTCConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.WebRTCConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebRTCConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIceserversList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.talk_api.ICEServer.serializeBinaryToWriter
    );
  }
  f = message.getAudiocodec();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSamplerate();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated ICEServer iceServers = 1;
 * @return {!Array<!proto.talk_api.ICEServer>}
 */
proto.talk_api.WebRTCConfig.prototype.getIceserversList = function() {
  return /** @type{!Array<!proto.talk_api.ICEServer>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.talk_api.ICEServer, 1));
};


/**
 * @param {!Array<!proto.talk_api.ICEServer>} value
 * @return {!proto.talk_api.WebRTCConfig} returns this
*/
proto.talk_api.WebRTCConfig.prototype.setIceserversList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.talk_api.ICEServer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.talk_api.ICEServer}
 */
proto.talk_api.WebRTCConfig.prototype.addIceservers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.talk_api.ICEServer, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.talk_api.WebRTCConfig} returns this
 */
proto.talk_api.WebRTCConfig.prototype.clearIceserversList = function() {
  return this.setIceserversList([]);
};


/**
 * optional string audioCodec = 2;
 * @return {string}
 */
proto.talk_api.WebRTCConfig.prototype.getAudiocodec = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.talk_api.WebRTCConfig} returns this
 */
proto.talk_api.WebRTCConfig.prototype.setAudiocodec = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 sampleRate = 3;
 * @return {number}
 */
proto.talk_api.WebRTCConfig.prototype.getSamplerate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.WebRTCConfig} returns this
 */
proto.talk_api.WebRTCConfig.prototype.setSamplerate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.WebTalkRequest.oneofGroups_ = [[1,2,3,4,5,6,7,8]];

/**
 * @enum {number}
 */
proto.talk_api.WebTalkRequest.RequestCase = {
  REQUEST_NOT_SET: 0,
  INITIALIZATION: 1,
  CONFIGURATION: 2,
  MESSAGE: 3,
  SIGNALING: 4,
  METADATA: 5,
  METRIC: 6,
  DISCONNECTION: 7,
  TOOLCALLRESULT: 8
};

/**
 * @return {proto.talk_api.WebTalkRequest.RequestCase}
 */
proto.talk_api.WebTalkRequest.prototype.getRequestCase = function() {
  return /** @type {proto.talk_api.WebTalkRequest.RequestCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.WebTalkRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.WebTalkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.WebTalkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.WebTalkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebTalkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    initialization: (f = msg.getInitialization()) && talk$api_pb.ConversationInitialization.toObject(includeInstance, f),
    configuration: (f = msg.getConfiguration()) && talk$api_pb.ConversationConfiguration.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && talk$api_pb.ConversationUserMessage.toObject(includeInstance, f),
    signaling: (f = msg.getSignaling()) && proto.talk_api.ClientSignaling.toObject(includeInstance, f),
    metadata: (f = msg.getMetadata()) && talk$api_pb.ConversationMetadata.toObject(includeInstance, f),
    metric: (f = msg.getMetric()) && talk$api_pb.ConversationMetric.toObject(includeInstance, f),
    disconnection: (f = msg.getDisconnection()) && talk$api_pb.ConversationDisconnection.toObject(includeInstance, f),
    toolcallresult: (f = msg.getToolcallresult()) && talk$api_pb.ConversationToolCallResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.WebTalkRequest}
 */
proto.talk_api.WebTalkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.WebTalkRequest;
  return proto.talk_api.WebTalkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.WebTalkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.WebTalkRequest}
 */
proto.talk_api.WebTalkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new talk$api_pb.ConversationInitialization;
      reader.readMessage(value,talk$api_pb.ConversationInitialization.deserializeBinaryFromReader);
      msg.setInitialization(value);
      break;
    case 2:
      var value = new talk$api_pb.ConversationConfiguration;
      reader.readMessage(value,talk$api_pb.ConversationConfiguration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    case 3:
      var value = new talk$api_pb.ConversationUserMessage;
      reader.readMessage(value,talk$api_pb.ConversationUserMessage.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 4:
      var value = new proto.talk_api.ClientSignaling;
      reader.readMessage(value,proto.talk_api.ClientSignaling.deserializeBinaryFromReader);
      msg.setSignaling(value);
      break;
    case 5:
      var value = new talk$api_pb.ConversationMetadata;
      reader.readMessage(value,talk$api_pb.ConversationMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 6:
      var value = new talk$api_pb.ConversationMetric;
      reader.readMessage(value,talk$api_pb.ConversationMetric.deserializeBinaryFromReader);
      msg.setMetric(value);
      break;
    case 7:
      var value = new talk$api_pb.ConversationDisconnection;
      reader.readMessage(value,talk$api_pb.ConversationDisconnection.deserializeBinaryFromReader);
      msg.setDisconnection(value);
      break;
    case 8:
      var value = new talk$api_pb.ConversationToolCallResult;
      reader.readMessage(value,talk$api_pb.ConversationToolCallResult.deserializeBinaryFromReader);
      msg.setToolcallresult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.WebTalkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.WebTalkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.WebTalkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebTalkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInitialization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      talk$api_pb.ConversationInitialization.serializeBinaryToWriter
    );
  }
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      talk$api_pb.ConversationConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      talk$api_pb.ConversationUserMessage.serializeBinaryToWriter
    );
  }
  f = message.getSignaling();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.talk_api.ClientSignaling.serializeBinaryToWriter
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      talk$api_pb.ConversationMetadata.serializeBinaryToWriter
    );
  }
  f = message.getMetric();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      talk$api_pb.ConversationMetric.serializeBinaryToWriter
    );
  }
  f = message.getDisconnection();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      talk$api_pb.ConversationDisconnection.serializeBinaryToWriter
    );
  }
  f = message.getToolcallresult();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      talk$api_pb.ConversationToolCallResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional ConversationInitialization initialization = 1;
 * @return {?proto.talk_api.ConversationInitialization}
 */
proto.talk_api.WebTalkRequest.prototype.getInitialization = function() {
  return /** @type{?proto.talk_api.ConversationInitialization} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationInitialization, 1));
};


/**
 * @param {?proto.talk_api.ConversationInitialization|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setInitialization = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearInitialization = function() {
  return this.setInitialization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasInitialization = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ConversationConfiguration configuration = 2;
 * @return {?proto.talk_api.ConversationConfiguration}
 */
proto.talk_api.WebTalkRequest.prototype.getConfiguration = function() {
  return /** @type{?proto.talk_api.ConversationConfiguration} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationConfiguration, 2));
};


/**
 * @param {?proto.talk_api.ConversationConfiguration|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ConversationUserMessage message = 3;
 * @return {?proto.talk_api.ConversationUserMessage}
 */
proto.talk_api.WebTalkRequest.prototype.getMessage = function() {
  return /** @type{?proto.talk_api.ConversationUserMessage} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationUserMessage, 3));
};


/**
 * @param {?proto.talk_api.ConversationUserMessage|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setMessage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ClientSignaling signaling = 4;
 * @return {?proto.talk_api.ClientSignaling}
 */
proto.talk_api.WebTalkRequest.prototype.getSignaling = function() {
  return /** @type{?proto.talk_api.ClientSignaling} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.ClientSignaling, 4));
};


/**
 * @param {?proto.talk_api.ClientSignaling|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setSignaling = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearSignaling = function() {
  return this.setSignaling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasSignaling = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ConversationMetadata metadata = 5;
 * @return {?proto.talk_api.ConversationMetadata}
 */
proto.talk_api.WebTalkRequest.prototype.getMetadata = function() {
  return /** @type{?proto.talk_api.ConversationMetadata} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationMetadata, 5));
};


/**
 * @param {?proto.talk_api.ConversationMetadata|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setMetadata = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ConversationMetric metric = 6;
 * @return {?proto.talk_api.ConversationMetric}
 */
proto.talk_api.WebTalkRequest.prototype.getMetric = function() {
  return /** @type{?proto.talk_api.ConversationMetric} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationMetric, 6));
};


/**
 * @param {?proto.talk_api.ConversationMetric|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setMetric = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearMetric = function() {
  return this.setMetric(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasMetric = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ConversationDisconnection disconnection = 7;
 * @return {?proto.talk_api.ConversationDisconnection}
 */
proto.talk_api.WebTalkRequest.prototype.getDisconnection = function() {
  return /** @type{?proto.talk_api.ConversationDisconnection} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationDisconnection, 7));
};


/**
 * @param {?proto.talk_api.ConversationDisconnection|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setDisconnection = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearDisconnection = function() {
  return this.setDisconnection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasDisconnection = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ConversationToolCallResult toolCallResult = 8;
 * @return {?proto.talk_api.ConversationToolCallResult}
 */
proto.talk_api.WebTalkRequest.prototype.getToolcallresult = function() {
  return /** @type{?proto.talk_api.ConversationToolCallResult} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationToolCallResult, 8));
};


/**
 * @param {?proto.talk_api.ConversationToolCallResult|undefined} value
 * @return {!proto.talk_api.WebTalkRequest} returns this
*/
proto.talk_api.WebTalkRequest.prototype.setToolcallresult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.talk_api.WebTalkRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkRequest} returns this
 */
proto.talk_api.WebTalkRequest.prototype.clearToolcallresult = function() {
  return this.setToolcallresult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkRequest.prototype.hasToolcallresult = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.talk_api.WebTalkResponse.oneofGroups_ = [[8,9,10,11,12,13,14,15,17,19,20,21,22]];

/**
 * @enum {number}
 */
proto.talk_api.WebTalkResponse.DataCase = {
  DATA_NOT_SET: 0,
  INITIALIZATION: 8,
  CONFIGURATION: 9,
  INTERRUPTION: 10,
  USER: 11,
  ASSISTANT: 12,
  TOOLCALL: 13,
  TOOLCALLRESULT: 14,
  ERROR: 15,
  SIGNALING: 17,
  METADATA: 19,
  METRIC: 20,
  DISCONNECTION: 21,
  EVENT: 22
};

/**
 * @return {proto.talk_api.WebTalkResponse.DataCase}
 */
proto.talk_api.WebTalkResponse.prototype.getDataCase = function() {
  return /** @type {proto.talk_api.WebTalkResponse.DataCase} */(jspb.Message.computeOneofCase(this, proto.talk_api.WebTalkResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.talk_api.WebTalkResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.talk_api.WebTalkResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.talk_api.WebTalkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebTalkResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    initialization: (f = msg.getInitialization()) && talk$api_pb.ConversationInitialization.toObject(includeInstance, f),
    configuration: (f = msg.getConfiguration()) && talk$api_pb.ConversationConfiguration.toObject(includeInstance, f),
    interruption: (f = msg.getInterruption()) && talk$api_pb.ConversationInterruption.toObject(includeInstance, f),
    user: (f = msg.getUser()) && talk$api_pb.ConversationUserMessage.toObject(includeInstance, f),
    assistant: (f = msg.getAssistant()) && talk$api_pb.ConversationAssistantMessage.toObject(includeInstance, f),
    toolcall: (f = msg.getToolcall()) && talk$api_pb.ConversationToolCall.toObject(includeInstance, f),
    toolcallresult: (f = msg.getToolcallresult()) && talk$api_pb.ConversationToolCallResult.toObject(includeInstance, f),
    error: (f = msg.getError()) && talk$api_pb.ConversationError.toObject(includeInstance, f),
    signaling: (f = msg.getSignaling()) && proto.talk_api.ServerSignaling.toObject(includeInstance, f),
    metadata: (f = msg.getMetadata()) && talk$api_pb.ConversationMetadata.toObject(includeInstance, f),
    metric: (f = msg.getMetric()) && talk$api_pb.ConversationMetric.toObject(includeInstance, f),
    disconnection: (f = msg.getDisconnection()) && talk$api_pb.ConversationDisconnection.toObject(includeInstance, f),
    event: (f = msg.getEvent()) && talk$api_pb.ConversationEvent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.talk_api.WebTalkResponse}
 */
proto.talk_api.WebTalkResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.talk_api.WebTalkResponse;
  return proto.talk_api.WebTalkResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.talk_api.WebTalkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.talk_api.WebTalkResponse}
 */
proto.talk_api.WebTalkResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 8:
      var value = new talk$api_pb.ConversationInitialization;
      reader.readMessage(value,talk$api_pb.ConversationInitialization.deserializeBinaryFromReader);
      msg.setInitialization(value);
      break;
    case 9:
      var value = new talk$api_pb.ConversationConfiguration;
      reader.readMessage(value,talk$api_pb.ConversationConfiguration.deserializeBinaryFromReader);
      msg.setConfiguration(value);
      break;
    case 10:
      var value = new talk$api_pb.ConversationInterruption;
      reader.readMessage(value,talk$api_pb.ConversationInterruption.deserializeBinaryFromReader);
      msg.setInterruption(value);
      break;
    case 11:
      var value = new talk$api_pb.ConversationUserMessage;
      reader.readMessage(value,talk$api_pb.ConversationUserMessage.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 12:
      var value = new talk$api_pb.ConversationAssistantMessage;
      reader.readMessage(value,talk$api_pb.ConversationAssistantMessage.deserializeBinaryFromReader);
      msg.setAssistant(value);
      break;
    case 13:
      var value = new talk$api_pb.ConversationToolCall;
      reader.readMessage(value,talk$api_pb.ConversationToolCall.deserializeBinaryFromReader);
      msg.setToolcall(value);
      break;
    case 14:
      var value = new talk$api_pb.ConversationToolCallResult;
      reader.readMessage(value,talk$api_pb.ConversationToolCallResult.deserializeBinaryFromReader);
      msg.setToolcallresult(value);
      break;
    case 15:
      var value = new talk$api_pb.ConversationError;
      reader.readMessage(value,talk$api_pb.ConversationError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 17:
      var value = new proto.talk_api.ServerSignaling;
      reader.readMessage(value,proto.talk_api.ServerSignaling.deserializeBinaryFromReader);
      msg.setSignaling(value);
      break;
    case 19:
      var value = new talk$api_pb.ConversationMetadata;
      reader.readMessage(value,talk$api_pb.ConversationMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 20:
      var value = new talk$api_pb.ConversationMetric;
      reader.readMessage(value,talk$api_pb.ConversationMetric.deserializeBinaryFromReader);
      msg.setMetric(value);
      break;
    case 21:
      var value = new talk$api_pb.ConversationDisconnection;
      reader.readMessage(value,talk$api_pb.ConversationDisconnection.deserializeBinaryFromReader);
      msg.setDisconnection(value);
      break;
    case 22:
      var value = new talk$api_pb.ConversationEvent;
      reader.readMessage(value,talk$api_pb.ConversationEvent.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.talk_api.WebTalkResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.talk_api.WebTalkResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.talk_api.WebTalkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.talk_api.WebTalkResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getInitialization();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      talk$api_pb.ConversationInitialization.serializeBinaryToWriter
    );
  }
  f = message.getConfiguration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      talk$api_pb.ConversationConfiguration.serializeBinaryToWriter
    );
  }
  f = message.getInterruption();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      talk$api_pb.ConversationInterruption.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      talk$api_pb.ConversationUserMessage.serializeBinaryToWriter
    );
  }
  f = message.getAssistant();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      talk$api_pb.ConversationAssistantMessage.serializeBinaryToWriter
    );
  }
  f = message.getToolcall();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      talk$api_pb.ConversationToolCall.serializeBinaryToWriter
    );
  }
  f = message.getToolcallresult();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      talk$api_pb.ConversationToolCallResult.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      talk$api_pb.ConversationError.serializeBinaryToWriter
    );
  }
  f = message.getSignaling();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.talk_api.ServerSignaling.serializeBinaryToWriter
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      talk$api_pb.ConversationMetadata.serializeBinaryToWriter
    );
  }
  f = message.getMetric();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      talk$api_pb.ConversationMetric.serializeBinaryToWriter
    );
  }
  f = message.getDisconnection();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      talk$api_pb.ConversationDisconnection.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      talk$api_pb.ConversationEvent.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.talk_api.WebTalkResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional ConversationInitialization initialization = 8;
 * @return {?proto.talk_api.ConversationInitialization}
 */
proto.talk_api.WebTalkResponse.prototype.getInitialization = function() {
  return /** @type{?proto.talk_api.ConversationInitialization} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationInitialization, 8));
};


/**
 * @param {?proto.talk_api.ConversationInitialization|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setInitialization = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearInitialization = function() {
  return this.setInitialization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasInitialization = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ConversationConfiguration configuration = 9;
 * @return {?proto.talk_api.ConversationConfiguration}
 */
proto.talk_api.WebTalkResponse.prototype.getConfiguration = function() {
  return /** @type{?proto.talk_api.ConversationConfiguration} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationConfiguration, 9));
};


/**
 * @param {?proto.talk_api.ConversationConfiguration|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setConfiguration = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearConfiguration = function() {
  return this.setConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasConfiguration = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ConversationInterruption interruption = 10;
 * @return {?proto.talk_api.ConversationInterruption}
 */
proto.talk_api.WebTalkResponse.prototype.getInterruption = function() {
  return /** @type{?proto.talk_api.ConversationInterruption} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationInterruption, 10));
};


/**
 * @param {?proto.talk_api.ConversationInterruption|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setInterruption = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearInterruption = function() {
  return this.setInterruption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasInterruption = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional ConversationUserMessage user = 11;
 * @return {?proto.talk_api.ConversationUserMessage}
 */
proto.talk_api.WebTalkResponse.prototype.getUser = function() {
  return /** @type{?proto.talk_api.ConversationUserMessage} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationUserMessage, 11));
};


/**
 * @param {?proto.talk_api.ConversationUserMessage|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setUser = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasUser = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ConversationAssistantMessage assistant = 12;
 * @return {?proto.talk_api.ConversationAssistantMessage}
 */
proto.talk_api.WebTalkResponse.prototype.getAssistant = function() {
  return /** @type{?proto.talk_api.ConversationAssistantMessage} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationAssistantMessage, 12));
};


/**
 * @param {?proto.talk_api.ConversationAssistantMessage|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setAssistant = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearAssistant = function() {
  return this.setAssistant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasAssistant = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ConversationToolCall toolCall = 13;
 * @return {?proto.talk_api.ConversationToolCall}
 */
proto.talk_api.WebTalkResponse.prototype.getToolcall = function() {
  return /** @type{?proto.talk_api.ConversationToolCall} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationToolCall, 13));
};


/**
 * @param {?proto.talk_api.ConversationToolCall|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setToolcall = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearToolcall = function() {
  return this.setToolcall(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasToolcall = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional ConversationToolCallResult toolCallResult = 14;
 * @return {?proto.talk_api.ConversationToolCallResult}
 */
proto.talk_api.WebTalkResponse.prototype.getToolcallresult = function() {
  return /** @type{?proto.talk_api.ConversationToolCallResult} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationToolCallResult, 14));
};


/**
 * @param {?proto.talk_api.ConversationToolCallResult|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setToolcallresult = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearToolcallresult = function() {
  return this.setToolcallresult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasToolcallresult = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional ConversationError error = 15;
 * @return {?proto.talk_api.ConversationError}
 */
proto.talk_api.WebTalkResponse.prototype.getError = function() {
  return /** @type{?proto.talk_api.ConversationError} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationError, 15));
};


/**
 * @param {?proto.talk_api.ConversationError|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional ServerSignaling signaling = 17;
 * @return {?proto.talk_api.ServerSignaling}
 */
proto.talk_api.WebTalkResponse.prototype.getSignaling = function() {
  return /** @type{?proto.talk_api.ServerSignaling} */ (
    jspb.Message.getWrapperField(this, proto.talk_api.ServerSignaling, 17));
};


/**
 * @param {?proto.talk_api.ServerSignaling|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setSignaling = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearSignaling = function() {
  return this.setSignaling(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasSignaling = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional ConversationMetadata metadata = 19;
 * @return {?proto.talk_api.ConversationMetadata}
 */
proto.talk_api.WebTalkResponse.prototype.getMetadata = function() {
  return /** @type{?proto.talk_api.ConversationMetadata} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationMetadata, 19));
};


/**
 * @param {?proto.talk_api.ConversationMetadata|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setMetadata = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional ConversationMetric metric = 20;
 * @return {?proto.talk_api.ConversationMetric}
 */
proto.talk_api.WebTalkResponse.prototype.getMetric = function() {
  return /** @type{?proto.talk_api.ConversationMetric} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationMetric, 20));
};


/**
 * @param {?proto.talk_api.ConversationMetric|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setMetric = function(value) {
  return jspb.Message.setOneofWrapperField(this, 20, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearMetric = function() {
  return this.setMetric(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasMetric = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional ConversationDisconnection disconnection = 21;
 * @return {?proto.talk_api.ConversationDisconnection}
 */
proto.talk_api.WebTalkResponse.prototype.getDisconnection = function() {
  return /** @type{?proto.talk_api.ConversationDisconnection} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationDisconnection, 21));
};


/**
 * @param {?proto.talk_api.ConversationDisconnection|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setDisconnection = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearDisconnection = function() {
  return this.setDisconnection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasDisconnection = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional ConversationEvent event = 22;
 * @return {?proto.talk_api.ConversationEvent}
 */
proto.talk_api.WebTalkResponse.prototype.getEvent = function() {
  return /** @type{?proto.talk_api.ConversationEvent} */ (
    jspb.Message.getWrapperField(this, talk$api_pb.ConversationEvent, 22));
};


/**
 * @param {?proto.talk_api.ConversationEvent|undefined} value
 * @return {!proto.talk_api.WebTalkResponse} returns this
*/
proto.talk_api.WebTalkResponse.prototype.setEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.talk_api.WebTalkResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.talk_api.WebTalkResponse} returns this
 */
proto.talk_api.WebTalkResponse.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.talk_api.WebTalkResponse.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 22) != null;
};


goog.object.extend(exports, proto.talk_api);
